import React from 'react';
import FinanceReportList from './FinanceReportList/FinanceReportList.container';
import { useI18n } from 'utils/I18n/context';

const FinanceReportPage = () => {
    const { t } = useI18n();
    const staticNames = t?.financeReportPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content statistics finance-report">
                <div className="ibox">
                    <FinanceReportList />
                </div>
            </section>
        </React.Fragment>
    );
};

export default FinanceReportPage;
